export const addressTypes = [
    {key: 'Casa', value: "Casa"},
    {key: 'Departamento', value: "Departamento"},
    {key: 'Condominio', value: "Condominio"},
    {key: 'Residencial', value: "Residencial"},
    {key: 'Oficina', value: "Oficina"},
    {key: 'Galería', value: "Galería"},
    {key: 'Otro', value: "Otro"},
];

export const orderStatuses = [
    {key: 1, value: "PENDIENTE", color: 'cGris'},
    {key: 2, value: "CONFIRMADO", action: "CONFIRMAR", color: 'cAmarillo'},
    {key: 3, value: "ANULADO POR CLIENTE", color: 'cRojo', hidden: true},
    {key: 4, value: "ANULADO", action: "ANULAR", color: 'cRojo'},
    {key: 5, value: "ENTREGADO", action: "ENTREGAR", color: 'cVerde'},
    {key: 6, value: "RECHAZADO", action: "RECHAZAR", color: 'cRojo'}
];

export const productStatuses = [
    {key: 1, value: "ACTIVO", color: 'cVerde'},
    {key: 2, value: "SUSPENDIDO", color: 'cRojo'},
];


export const userStatuses = [
    {key: 1, value: "ACTIVO", color: 'cVerde'},
    {key: 2, value: "SUSPENDIDO", color: 'cRojo'},
];

export const paymentMethods = [
    {key: 0, value: "EFECTIVO"},
    {key: 1, value: "POS VISA"},
    {key: 2, value: "POS MASTERCARD"},
    {key: 3, value: "DEPÓSITO"},
    {key: 4, value: "TARJETA DE CRÉDITO"},
    {key: 5, value: "YAPE"},
];

export const companies = [
    {key: 'kimberly-clark', value: "Kimberly Clark"},
];

export const roles = [
    {key: 'ROLE_USER', value: "Usuario"},
    {key: 'ROLE_STORE', value: "Almacén"},
    {key: 'ROLE_SALES', value: "Ventas"},
    {key: 'ROLE_ADMIN', value: "Administrador"}
];



// WEBPACK FOOTER //
// ./src/util/options.js